import React from "react";

const SlidePage1 = () => {
  return (
    <div className="w-full  flex-col  lg:flex-row  flex justify-center lg:justify-between items-center px-6">
      <div className="basis-5/12 ">
        <h1 className="text-4xl  font-bold mb-8 text-sky-500 font-serif">
          Online <br />{" "}
          <span className="text-6xl font-extrabold">Shopping</span>
        </h1>
        <p className="text-sm mb-8 pr-10 md:block hidden ">
          met consectetur adipisicing elit. Laudantium, repudiandae deserunt et
          perspiciatis sint ea? adipisicing elit. Dolore dolores nam a placeat
          libero iste eius cupiditate aut animi maiores itaque impedit provident
          quibusdam, optio quae deserunt nemo sunt sapiente? Ducimus quas qui
          error.
        </p>
        <button className="px-6 py-2 mr-6 rounded-md text-white bg-sky-500  font-semibold text-md hover:bg-sky-700">
          Start now
        </button>
        <button className="px-6 py-2 rounded-md text-white bg-gray-800  font-semibold text-md hover:bg-gray-900">
          Join now
        </button>
      </div>
      <div className="basis-6/12 h-96  ">
        <img src="/images/success.gif" alt="" />
      </div>
    </div>
  );
};

export default SlidePage1;
